import { SubscriptionClient } from 'subscriptions-transport-ws';
import { SubscribeFunction, Observable } from 'relay-runtime';
import serverVars from 'server-vars';

import { getClientHeaders } from './src/getClientHeaders';
import { CreateFetcherArgs } from './client';
import { getBuyerToken } from 'dibs-cookie-jar';

type SetupSubscriptionArgs = {
    getQueries: CreateFetcherArgs['getQueries'];
    userType: CreateFetcherArgs['userType'];
};

const TWO_MINUTE_TIMEOUT = 2 * 60 * 1000;
const RECONNECTION_ATTEMPTS = 500; // probably want to set this to something, as the default is Infinity
const NODE_GRAPHQL_SUBSCRIPTIONS_URL = serverVars.get('NODE_GRAPHQL_SUBSCRIPTIONS_URL');

export function setupSubscriptions({
    getQueries = () => ({}),
    userType,
}: SetupSubscriptionArgs): SubscribeFunction {
    // init socket connection on first subscription query to avoid unnecessary connections
    let subscriptionClient: SubscriptionClient | undefined;
    function getSubscriptionClient(): SubscriptionClient {
        if (subscriptionClient) {
            return subscriptionClient;
        }
        subscriptionClient = new SubscriptionClient(NODE_GRAPHQL_SUBSCRIPTIONS_URL, {
            reconnect: true,
            reconnectionAttempts: RECONNECTION_ATTEMPTS,
            timeout: TWO_MINUTE_TIMEOUT,
            inactivityTimeout: 1, // close socket if unsubscribed from all, will open a new one on new subscription
            connectionParams: {
                headers: getClientHeaders(getQueries, userType),
                originalUrl: window.location.href,
            },
            connectionCallback: error => {
                // @ts-ignore https://github.com/apollographql/subscriptions-transport-ws/pull/509
                if (subscriptionClient && error?.message === 'Prohibited connection!') {
                    subscriptionClient.close(true, true);
                }
            },
        });
        subscriptionClient.use([
            {
                applyMiddleware(operationOptions, next) {
                    operationOptions.userToken = getBuyerToken(document.cookie).userToken;
                    next();
                },
            },
        ]);
        return subscriptionClient;
    }

    // @ts-ignore: Convert subscriptions-transport-ws observable type to Relay's
    return function subscriptionFunction(operation, variables) {
        return Observable.from(
            // @ts-ignore: ExecutionResultDataDefault vs PayloadData
            getSubscriptionClient().request({
                query: operation.text || 'use persisted query', // falsey value fails runtime validation
                id: operation.id,
                operationName: operation.name,
                variables,
            })
        );
    };
}
